/* eslint-disable import/prefer-default-export */
export const GET_DEDICATED_CONNECTED_USERS = 'GET_DEDICATED_CONNECTED_USERS';
